import React from 'react';
import Icon from './Icon';

const STATS = [
  { icon: 'calendar', value: '10+', label: 'Years of Experience' },
  { icon: 'users', value: '20+', label: 'Clients Served' },
  { icon: 'briefcase', value: '30+', label: 'Projects Delivered' },
  { icon: 'award', value: '98%', label: 'Client Satisfaction' },
];

export default function About() {
  return (
    <section id="about" className="section">
      <div className="container about-grid">
        <div className="about-visual reveal">
          <div className="about-panel">
            <Icon name="layers" size={54} />
          </div>
          <div className="about-floater f1"><Icon name="shield-check" size={20} /></div>
          <div className="about-floater f2"><Icon name="cpu" size={20} /></div>
          <div className="about-floater f3"><Icon name="cloud" size={20} /></div>
        </div>

        <div className="about-content reveal">
          <span className="eyebrow">About Buildstrust</span>
          <h2 className="section-title">Your Strategic Technology Partner</h2>
          <p className="about-text">
            With years of experience in IT operations, digital transformation, and automation
            consulting, we help organizations modernize their technology landscape and create
            sustainable business growth. We combine enterprise-grade methodology with a boutique
            level of attention — so every client gets a partner, not just a provider.
          </p>

          <div className="about-stats">
            {STATS.map((s) => (
              <div className="about-stat" key={s.label}>
                <Icon name={s.icon} size={20} />
                <div>
                  <strong>{s.value}</strong>
                  <span>{s.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}